import axios from "axios";
import Vue from 'vue';
const vm = new Vue()
const methods = ["get", "post"]
const prefix = "/api",
    suffix = ""
let ajax = axios.create({
    //超时时间
    timeout: 15000
})

const fetch = {}
ajax.interceptors.request.use(config => {
    config.headers.auth=sessionStorage.getItem("token")||""
    config.url = prefix + config.url + suffix
    return config
}, error => {
    return new Promise.reject(error)
})
const errorMsg = {
    400: "请求错误",
    401: "未授权，请重新登录",
    403: "拒绝访问",
    404: "请求错误,未找到该资源",
    405: "请求方法未允许",
    408: "请求超时",
    500: "服务器端出错",
    501: "网络未实现",
    502: "网络错误",
    503: "服务不可用",
    504: "网络超时",
    505: "http版本不支持该请求"
};

ajax.interceptors.response.use(response => {
    return response
}, error => {
    // 请求错误时做些事
    if (error && error.response) {
        let errMsg = errorMsg[error.response.status]
        error.message = errMsg ? errMsg : `连接错误${error.response.status}`

    } else {
        error.message = "连接到服务器失败"
    }

    vm.$notify({
        title: '温馨提示',
        message: error.message,
        position: 'top-right'
    });
    return new Promise(error)
})
methods.forEach(item => {
    fetch[item] = function (url, data, config={}) {
        let loadingInstance;
        if (url.indexOf('User/Login') == -1) {
            //非登录接口请求增加loading
            loadingInstance = vm.$loading({
                text: "数据请求中...",
                target: ".layout_main",
                background: "rgba(255,255,255,.6)"
            })
        }

        return new Promise(function (resolve, reject) {
            ajax[item](url, data, config).then(response => {
                loadingInstance && loadingInstance.close()
                if (response.data.status === 1) {
                    resolve(response.data);
                } else if(response.data.status===401){
                    vm.$notify({
                        title: '温馨提示',
                        message: "未授权，请重新登录系统",
                        position: 'top-right'
                    });
                    sessionStorage.clear();
                    vm.$router.replace('/Login')
                }else {
                    vm.$notify({
                        title: '温馨提示',
                        message: response.data.message,
                        position: 'top-right'
                    });
                    reject(response.data.message)
                }
            }).catch(error => {
                loadingInstance && loadingInstance.close()
                reject(error.message)
            })
        })
    }
})

Plugin.install = function (Vue, options) {
    Vue.axios = ajax;
    window.axios = ajax;
    Object.defineProperties(Vue.prototype, {
        axios: {
            get() {
                return ajax;
            }
        },
        $axios: {
            get() {
                return fetch;
            }
        },
    });
};

Vue.use(Plugin)

export default Plugin;